import { unitMapping } from 'lib/style';

type Props = {
  size?: keyof typeof unitMapping;
};

export const Binoculars = ({ size = 2 }: Props) => {
  return (
    <svg
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.70198 5.95003C3.11668 4.89996 4.97034 4.89999 6.33834 5.95011H6.77031L5.60011 3.5H3.85011C3.45308 3.99629 2.68386 4.82097 1.91913 5.64086L1.63088 5.95003H1.70198Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.96738 10.8001C6.49267 11.9728 5.34294 12.8001 3.99999 12.8001C2.23268 12.8001 0.799988 11.3674 0.799988 9.60007C0.799988 7.83275 2.23268 6.40007 3.99999 6.40007C5.34294 6.40007 6.49267 7.22733 6.96738 8.40006H9.03259C9.50731 7.22733 10.657 6.40007 12 6.40007C13.7673 6.40007 15.2 7.83275 15.2 9.60007C15.2 11.3674 13.7673 12.8001 12 12.8001C10.657 12.8001 9.5073 11.9728 9.03259 10.8001H6.96738ZM3.99999 11.2001C4.88364 11.2001 5.59999 10.4837 5.59999 9.60007C5.59999 8.71641 4.88364 8.00007 3.99999 8.00007C3.11633 8.00007 2.39999 8.71641 2.39999 9.60007C2.39999 10.4837 3.11633 11.2001 3.99999 11.2001ZM12 11.2001C12.8836 11.2001 13.6 10.4837 13.6 9.60007C13.6 8.71641 12.8836 8.00007 12 8.00007C11.1163 8.00007 10.4 8.71641 10.4 9.60007C10.4 10.4837 11.1163 11.2001 12 11.2001ZM8.7 9.64992C8.7 10.0089 8.40899 10.2999 8.05 10.2999C7.69102 10.2999 7.4 10.0089 7.4 9.64992C7.4 9.29093 7.69102 8.99992 8.05 8.99992C8.40899 8.99992 8.7 9.29093 8.7 9.64992Z"
        fill="currentColor"
      />
      <path
        d="M14.1983 5.95011C12.7836 4.89999 10.93 4.89996 9.56194 5.95003H9.1299L10.3001 3.5H12.0501C12.4471 3.99629 13.2163 4.82097 13.981 5.64085L14.2694 5.95011H14.1983Z"
        fill="currentColor"
      />
    </svg>
  );
};
